import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subject, firstValueFrom, takeUntil } from 'rxjs';
import { AlertService } from '../../../../../core/services/alert/alert.service';
import { ApiService } from '../../../../../core/services/api/api.service';
import { ToastService } from '../../../../../core/services/toast/toast.service';
import { EnfafModalComponent } from '../../../../../components/enfaf-modal/enfaf-modal.component';
import { EnfafInputComponent } from '../../../../../components/enfaf-input/enfaf-input.component';
import { EnfafSelectLightComponent } from '../../../../../components/enfaf-select-light/enfaf-select-light.component';
import { Role } from '../../../../../models/enums/role.enum';
import { formatRole } from '../../../../../shared/utils/format-role.util';

@Component({
  selector: 'app-modal-add-admin',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    EnfafModalComponent,
    EnfafInputComponent,
    EnfafSelectLightComponent
  ],
  templateUrl: './modal-add-user.component.html',
  styleUrl: './modal-add-user.component.scss'
})
export class ModalAddAdminComponent implements OnInit, OnDestroy {
  adminForm: FormGroup = this.fb.group({
    email: new FormControl(null, [Validators.required, Validators.email]),
    // password: new FormControl(null, [Validators.required, Validators.minLength(6)]),
    name: new FormControl(null, Validators.required),
    lastname: new FormControl(null, Validators.required),
    role: new FormControl(null, Validators.required)
  });

  showCloseAlert = false;
  isSavingAdmin = false;
  // hidePassword = true;

  roleOptions = [
    { value: Role.God, viewValue: formatRole(Role.God) },
    { value: Role.Teacher, viewValue: formatRole(Role.Teacher) },
    { value: Role.Tutor, viewValue: formatRole(Role.Tutor) },
    { value: Role.Student, viewValue: formatRole(Role.Student) },
    { value: Role.ContentDirector, viewValue: formatRole(Role.ContentDirector) }
  ];

  private unsubscribe$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalAddAdminComponent>,
    private alert: AlertService,
    private api: ApiService,
    private toast: ToastService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.listenForChanges();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  listenForChanges(): void {
    this.adminForm.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((value) => {
      this.showCloseAlert = true;
    });
  }

  async confirmCloseModal(): Promise<any> {
    if (this.showCloseAlert) {
      const closeModal = await this.alert.presentCloseWindowAlert();
      return closeModal ? this.closeModal() : null;
    }

    this.closeModal();
  }

  closeModal(result?: any): void {
    this.dialogRef.close(result);
  }

  // generateRandomPassword(): void {
  //   const randomPassword = generate({
  //     lowercase: true,
  //     numbers: true,
  //     uppercase: true,
  //     symbols: false,
  //     length: 10,
  //     strict: true
  //   });
  //   this.adminForm.controls.password.setValue(randomPassword);
  // }

  async saveUser(): Promise<void> {
    try {
      this.isSavingAdmin = true;
      const body = {
        ...this.adminForm.value
      };
      body.email = body.email.trim().toLowerCase();
      const response = await firstValueFrom(this.api.saveNewAdmin(body));
      this.isSavingAdmin = false;
      this.closeModal({ newAdmin: response.newAdmin });
      this.toast.presentSuccessToast(response.message);
    } catch (errorResponse: any) {
      this.isSavingAdmin = false;
      const errorMessage = errorResponse?.error?.message;
      this.toast.presentErrorToast(errorMessage || 'Hubo un error guardando administrador');
    }
  }
}
